"use strict";

exports.__esModule = true;
exports.ClassificationButton = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _core = require("@blueprintjs/core");
var _polished = require("polished");
var _VimanaIcon = require("../../VimanaIcon");
var _Theme = require("../../Theme");
var _getPlantStateColor = require("../../PlantStateActivities/getPlantStateColor");
var _UserAction = require("../../UserActions/UserAction");
var _userActionsContext = require("../../UserActions/userActionsContext");
var _excluded = ["state", "activity", "disabled", "onClickAction", "rank", "onClassifyClick", "userActions"];
var _class, _ClassificationButton;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
// A reason button built for touch: tall and bold, the state colour as a
// tint (background) on a button floating on a soft shadow. The next-gen
// design paints only the hero state block solid.
var tint = function tint(theme, state, amount) {
  return (0, _polished.mix)(amount, (0, _getPlantStateColor.getPlantStateColor)(theme, state.id) || "#c7cfd5", "#ffffff");
};
var WorkflowPanel = _styledComponents["default"].div.withConfig({
  displayName: "ClassificationButtonmodern__WorkflowPanel",
  componentId: "sc-7eyxt5-0"
})(["background:", ";border-radius:6px;padding:2px 4px;margin-right:8px;display:flex;align-items:center;justify-content:center;"], function (_ref) {
  var state = _ref.state,
    theme = _ref.theme;
  return tint(theme, state, 0.35);
});
var ClassificationButtonView = _styledComponents["default"].button.withConfig({
  displayName: "ClassificationButtonmodern__ClassificationButtonView",
  componentId: "sc-7eyxt5-1"
})(["box-sizing:border-box;display:flex;flex:1;justify-content:flex-start;align-items:center;text-align:left;min-height:84px;font-weight:700;font-size:18px;line-height:1.25;padding:16px 20px;color:#1b2227;background:", ";border:0;border-radius:10px;box-shadow:", ";position:relative;touch-action:manipulation;-webkit-tap-highlight-color:transparent;user-select:none;transition:background-color 120ms ease,box-shadow 120ms ease,transform 120ms ease;outline:none;overflow:hidden;opacity:", ";&.", "{min-height:96px;font-size:20px;padding:18px 22px;}&:hover:not([disabled]){cursor:pointer;background:", ";box-shadow:", ";transform:translateY(-1px);}&:active:not([disabled]){background:", ";box-shadow:", ";transform:scale(0.985);}&[disabled]{cursor:default;}"], function (_ref2) {
  var state = _ref2.state,
    theme = _ref2.theme;
  return tint(theme, state, 0.18);
}, (0, _Theme.val)("ButtonShadow"), function (props) {
  return props.disabled ? "0.55" : "1";
}, _core.Classes.LARGE, function (_ref3) {
  var state = _ref3.state,
    theme = _ref3.theme;
  return tint(theme, state, 0.3);
}, (0, _Theme.val)("ButtonShadowHover"), function (_ref4) {
  var state = _ref4.state,
    theme = _ref4.theme;
  return tint(theme, state, 0.42);
}, (0, _Theme.val)("ButtonShadow"));

/**
 * Allows an operator to classify a cycle according to the given state / activity.
 */
var ClassificationButton = exports.ClassificationButton = (0, _userActionsContext.withUserActionsContext)(_class = (_ClassificationButton = /*#__PURE__*/function (_Component) {
  function ClassificationButton() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.handleClick = function (invoke) {
      var _this$props = _this.props,
        state = _this$props.state,
        activity = _this$props.activity,
        rank = _this$props.rank,
        onClassifyClick = _this$props.onClassifyClick;
      if (typeof onClassifyClick === "function") {
        onClassifyClick({
          state: state,
          activity: activity,
          rank: rank
        });
        if (invoke) {
          invoke();
        }
      }
    };
    _this.body = function (invoke) {
      var _this$props2 = _this.props,
        state = _this$props2.state,
        activity = _this$props2.activity,
        disabled = _this$props2.disabled,
        onClickAction = _this$props2.onClickAction,
        rank = _this$props2.rank,
        onClassifyClick = _this$props2.onClassifyClick,
        userActions = _this$props2.userActions,
        extra = _objectWithoutPropertiesLoose(_this$props2, _excluded);
      var clickedAction = onClickAction && userActions && userActions.find(function (action) {
        return action.name === onClickAction.name;
      });
      return /*#__PURE__*/_react["default"].createElement(ClassificationButtonView, _extends({
        state: state
      }, extra, {
        disabled: disabled,
        type: "button",
        onClick: function onClick() {
          return _this.handleClick(invoke);
        }
      }), clickedAction && /*#__PURE__*/_react["default"].createElement(WorkflowPanel, {
        state: state
      }, /*#__PURE__*/_react["default"].createElement(_VimanaIcon.VimanaIcon, {
        margin: "0",
        icon: clickedAction.icon,
        iconSize: 20,
        alt: clickedAction.name
      })), activity ? activity.name : state.name);
    };
    return _this;
  }
  _inheritsLoose(ClassificationButton, _Component);
  var _proto = ClassificationButton.prototype;
  _proto.render = function render() {
    var _this2 = this;
    var onClickAction = this.props.onClickAction;
    if (!onClickAction) {
      return this.body();
    }
    return /*#__PURE__*/_react["default"].createElement(_UserAction.UserAction, onClickAction, function (_ref5) {
      var invoke = _ref5.invoke;
      return _this2.body(invoke);
    });
  };
  return ClassificationButton;
}(_react.Component), _ClassificationButton.defaultProps = {
  rank: 0
}, _ClassificationButton)) || _class;